import { Checkbox, Form, Input, Select, Space, TimePicker } from 'antd';
import React, { useEffect } from 'react';

import { EDUTAINMENT_PLACE_OPTIONS } from '../constants';
import type { FixedTime } from '../types';
import { DAYS } from './constants';
import {
  validateFixedScheduleField,
  validateIfAllFieldsEmpty,
} from './helpers';
import styles from './index.module.scss';

const { Item, List, useFormInstance, useWatch, ErrorList } = Form;

export const FixedSchedule = () => {
  const form = useFormInstance();

  const fixedSchedule = useWatch<FixedTime[] | undefined>('fixedSchedule');

  useEffect(() => {
    return () => {
      form.resetFields(['fixedSchedule']);
    };
  }, [form]);

  // TODO: 固定時間的地點，看是要用哪些資料組成
  const placeOptions = [
    ...EDUTAINMENT_PLACE_OPTIONS,
    { label: '其他', value: '其他' },
  ];

  return (
    <>
      <h5 className={styles.fixedScheduleFieldTitle}>每週上課時間</h5>
      <List
        name="fixedSchedule"
        rules={[
          {
            validator: (_, fixedSchedule) =>
              validateIfAllFieldsEmpty(fixedSchedule),
          },
        ]}
      >
        {(fields, _, { errors }) => (
          <>
            <ErrorList errors={errors} />
            {fields.map((field) => {
              const day = DAYS[field.name];
              const shouldDisableAddressInput = fixedSchedule
                ? fixedSchedule[field.name].place !== '其他'
                : true;

              return (
                <div key={field.key} className={styles.field}>
                  <Item
                    name={[field.name, 'isDayChecked']}
                    rules={[
                      {
                        validator: (_, value) =>
                          fixedSchedule
                            ? validateFixedScheduleField({
                                fixedSchedule,
                                value,
                                fieldKey: [field.name, 'isDayChecked'],
                              })
                            : Promise.resolve(),
                      },
                    ]}
                    valuePropName="checked"
                  >
                    <Checkbox>{`週${day}`}</Checkbox>
                  </Item>

                  <Space>
                    <div className={styles.fieldItemWithText}>
                      <p>時間：</p>
                      <Item
                        name={[field.name, 'startTime']}
                        rules={[
                          {
                            validator: (_, value) =>
                              fixedSchedule
                                ? validateFixedScheduleField({
                                    fixedSchedule,
                                    value,
                                    fieldKey: [field.name, 'startTime'],
                                  })
                                : Promise.resolve(),
                          },
                        ]}
                      >
                        <TimePicker
                          className={styles.timePicker}
                          placeholder="請選擇起始時間"
                          format="HH:mm"
                        />
                      </Item>
                    </div>
                    <Item
                      name={[field.name, 'endTime']}
                      rules={[
                        {
                          validator: (_, value) =>
                            fixedSchedule
                              ? validateFixedScheduleField({
                                  fixedSchedule,
                                  value,
                                  fieldKey: [field.name, 'endTime'],
                                })
                              : Promise.resolve(),
                        },
                      ]}
                    >
                      <TimePicker
                        className={styles.timePicker}
                        placeholder="請選擇結束時間"
                        format="HH:mm"
                      />
                    </Item>
                  </Space>

                  <Space>
                    <div className={styles.fieldItemWithText}>
                      <p>地點：</p>
                      <Item
                        name={[field.name, 'place']}
                        rules={[
                          {
                            validator: (_, value) =>
                              fixedSchedule
                                ? validateFixedScheduleField({
                                    fixedSchedule,
                                    value,
                                    fieldKey: [field.name, 'place'],
                                  })
                                : Promise.resolve(),
                          },
                        ]}
                      >
                        <Select
                          className={styles.selector}
                          placeholder="請選擇地點"
                          options={placeOptions}
                          onChange={() =>
                            form.setFieldValue(
                              ['fixedSchedule', field.name, 'address'],
                              null
                            )
                          }
                        />
                      </Item>
                    </div>
                    <Item
                      name={[field.name, 'address']}
                      rules={[
                        {
                          validator: (_, value) =>
                            fixedSchedule
                              ? validateFixedScheduleField({
                                  fixedSchedule,
                                  value,
                                  fieldKey: [field.name, 'address'],
                                })
                              : Promise.resolve(),
                        },
                      ]}
                    >
                      <Input
                        className={styles.address}
                        placeholder="請輸入地址"
                        disabled={shouldDisableAddressInput}
                      />
                    </Item>
                  </Space>
                </div>
              );
            })}
          </>
        )}
      </List>
    </>
  );
};
